import { withTranslation } from "react-i18next";

import React from 'react';
import { Link } from 'react-router-dom';
import { Header, Footer } from '../Common';
import Notifications from '../../Models/Notifications';
import { BuyerSidebar } from '../Common/BuyerSidebar';
import { SideBar } from '../Common/SideBar';
import { AffiliatorSidebar } from '../Common/AffiliatorSidebar';

class SystemNotification extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            allNotifications: []
        }
        console.log(this.props.location.state.id)
        this.getNotification(this.props.location.state.id)
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    getNotification(id) {
        if (localStorage.getItem('info') !== null) {
            var x = JSON.parse(localStorage.getItem('info'))
            Notifications.getSystemNotification(x.id, id).then(res => {
                if (res.data.payload !== null) {
                    this.setState({ allNotifications: res.data.payload })
                }
            })
        }
    }

    showSidebar() {
        if (localStorage.getItem('info') !== null) {
            var x = JSON.parse(localStorage.getItem('info'))
            if (x.user_type_id === 1) {
                return (
                    <BuyerSidebar />
                )
            } else if (x.user_type_id === 2) {
                return (
                    <SideBar />
                )
            } else if (x.user_type_id === 3) {
                return (
                    <AffiliatorSidebar />
                )
            }
        }
    }

    render() {
        const renderHTML = (rawHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
        return (
            <div className="">
                <Header />
                <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                <div className="col-md-12 tr_blank_medium mt-5 "></div>
                <div className="container-fluid">
                    <div className="container">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-4 input_name">
                                    {this.showSidebar()}
                                </div>
                                <div className="col-md-8">
                                    <div className="">
                                        {this.props.t('0')}
                                    </div>
                                    <hr />
                                    <div className="top_back">
                                        {renderHTML(this.state.allNotifications.notification_text)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer/>
            </div>
        )
    }
}
export { SystemNotification }

 SystemNotification = withTranslation('src_Components_Notification_SystemNotification')(SystemNotification);